export default __webpack_public_path__ + "static/media/support-team-anthony.39df0555.png";